import mod from "-!./_CreateNewRide.js?vue&type=script&lang=js&"; export default mod; export * from "-!./_CreateNewRide.js?vue&type=script&lang=js&"